module.exports = __webpack_public_path__ + "82ef3a44fdfd477fb7e8292946df4c6e.woff2";